import React, { Component } from 'react'
import "./styles.scss";
export default function ButtonForm({children, ...otherProps}) {
    return(
        <button className='btn' {...otherProps}>
            {children}
        </button>
    )
}